import type { ReactNode } from 'react';

interface PageHeaderProps {
  title: string;
  description?: string;
  actions?: ReactNode;
  testId?: string;
  kicker?: string;
}

export function PageHeader({ title, description, actions, testId, kicker = 'Workspace' }: PageHeaderProps) {
  return (
    <div className="page-heading-wrap" data-testid={testId}>
      <div className="min-w-0 flex-1">
        <p className="page-heading-kicker">{kicker}</p>
        <h1 className="page-heading-title">{title}</h1>
        {description && <p className="page-heading-description">{description}</p>}
      </div>
      {actions && <div className="flex shrink-0 flex-wrap items-center gap-2">{actions}</div>}
    </div>
  );
}
